<template>
    <div class="report__dashboard_show_coursecompletionoverview">
        <div class="report__dashboard_show_coursecompletionoverview_header">
            <component-filters-dashboard-reports
                :filter-key="'course_completion'"
                :search-active="true"
                :search-value="filterSearch"
                @emit-search="handleFilterSearch"
                @emit-submit-request="performGetData"
                @emit-get-request="performGetData"
            ></component-filters-dashboard-reports>
        </div>
        <div class="report__dashboard_show_coursecompletionoverview_main">
            <div class="container">
                <template v-if="requestPending">
                    <component-loading :size="'small'"></component-loading>
                </template>
                <template v-else>
                    <template v-if="courseCompletionsOverviewData.length">
                        <report-dashboard-show-course-completion-overview-table
                            :items="courseCompletionsOverviewData"
                        ></report-dashboard-show-course-completion-overview-table>
                    </template>
                    <template v-else-if="filterSearch">
                        <component-empty-state
                            :submit-button-active="false"
                        ></component-empty-state>
                    </template>
                    <template v-else>
                        <component-empty-state
                            :title="'No courses have been added to your Workspace yet. \n As soon as your first course has been added, enrolments and completions will be displayed here.'"
                            :submit-button-active="false"
                        ></component-empty-state>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import ComponentFiltersDashboardReports from '@/components/default/shared/ComponentFiltersDashboardReports'
import ComponentLoading from '@/components/default/shared/ComponentLoading'
import ComponentEmptyState from '@/components/default/shared/ComponentEmptyState'
import ReportDashboardShowCourseCompletionOverviewTable from '@/components/ebs/reports/dashboard/show/ReportDashboardShowCourseCompletionOverviewTable'

export default {
  name: 'report-dashboard-show-course-completion-overview',
  components: {
    ReportDashboardShowCourseCompletionOverviewTable,
    ComponentEmptyState,
    ComponentLoading,
    ComponentFiltersDashboardReports
  },
  data () {
    return {
      requestPending: true,
      filterSearch: ''
    }
  },
  computed: {
    courseCompletionsOverviewData () {
      const rawData = this.$store.getters.getEbsReportDashboardDataCourseCompletionOverview
      const filterSearch = this.filterSearch.toLowerCase()
      const filteredData = rawData.filter(obj => obj.name.toLowerCase().includes(filterSearch))
      return filterSearch ? filteredData : rawData
    }
  },
  methods: {
    performGetData () {
      this.requestPending = true
      this.$store.dispatch('ebsReportDashboardGetDataCourseCompletion').finally(() => {
        this.requestPending = false
      })
    },
    handleFilterSearch (data) {
      this.filterSearch = data
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/reports/_reportdashboardcoursecompletionoverview.scss";
</style>
